<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-card-title>Agencies</v-card-title>
      <v-card-text>Manage agencies</v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Renewals</v-card-title>
      <v-card-text>Manage agency renewals</v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Add Agency</v-card-title>
      <v-card-text>Add a new agency</v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      agency: {}
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/okdmv/Okdmv.vue